<ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: data }" style="cursor: pointer;"></ng-container>
